import React from 'react';
import { useSeamlessImageSrc } from '../utils/useSeamlessImageSrc';

type AvatarImageProps = {
    src: string;
    alt: string;
    className: string;
    onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
    style?: React.CSSProperties;
};

/** Renders an avatar img only after the src has preloaded, keeping the previous image visible during swaps. */
export default function AvatarImage({ src, alt, className, onError, style }: AvatarImageProps) {
    const { displaySrc } = useSeamlessImageSrc(src);

    if (!displaySrc) {
        return null;
    }

    return (
        <img
            src={displaySrc}
            alt={alt}
            className={className}
            onError={onError}
            style={style}
        />
    );
}
